module.exports = __webpack_public_path__ + "img/google-btn.9752eda6.svg";